import { connect } from 'react-redux';

import LevelOverview from 'components/molecules/LevelOverview';
import { getAllLevels } from 'store/mySuccess';

const mapStateToProps = (state) => ({
	allLevels: getAllLevels(state),
});

export default connect(mapStateToProps)(LevelOverview as any);
